import { render, staticRenderFns } from "./VirtualDelegateAttendeeFAQ.vue?vue&type=template&id=095251c2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports